// Google Analytics 4 utility
// Measurement ID: G-8B24JEER65

declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
    dataLayer: unknown[];
  }
}

const GA_MEASUREMENT_ID = 'G-8B24JEER65';

/**
 * Track a page view
 */
export function trackPageView(pageName: string, pageLocation?: string) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_title: pageName,
    page_location: pageLocation || window.location.href,
  });
}

/**
 * Track a custom event
 */
export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, {
    ...params,
  });
}

// Pre-defined event helpers for common actions
export const analytics = {
  // Session events
  sessionViewed: (vin: string | null, sessionKey: string) => {
    trackEvent('session_viewed', { vin, session_key: sessionKey });
  },

  // Vehicle events
  vehicleViewed: (vin: string) => {
    trackEvent('vehicle_viewed', { vin });
  },

  // Data loading events
  commlogLoaded: (vin: string | null, sessionCount: number) => {
    trackEvent('commlog_loaded', { vin, session_count: sessionCount });
  },

  // Chart interaction
  telemetryChartInteraction: (action: 'toggle_pid' | 'hover', pidName?: string) => {
    trackEvent('telemetry_chart_interaction', { action, pid_name: pidName });
  },

  // Vehicle lookup buttons
  vehicleLookupClicked: (lookupType: string) => {
    trackEvent('vehicle_lookup_clicked', { lookup_type: lookupType });
  },

  // Filter events
  filterApplied: (filterType: string, filterValue?: string) => {
    trackEvent('filter_applied', { filter_type: filterType, filter_value: filterValue });
  },

  // Auth events
  loginSuccess: (email?: string) => {
    trackEvent('login_success', { email_domain: email?.split('@')[1] });
  },

  // Report events
  exportReport: (reportType: string, vin?: string) => {
    trackEvent('export_report', { report_type: reportType, vin });
  },
};
